import React from 'react';
import { Menu, Icon, Button } from 'antd';
import { MujiLink } from '@souche-f2e/muji';
import { withRouter } from '@souche-f2e/muji';
import styles from './menu.module.less';

const { Item } = Menu;

@withRouter
class AppMenu extends React.Component {
  constructor() {
    super();
  }

  render() {
    const path = this.props.router.history.current.path;
    const defaultSelectedKeys = [path];

    const options = {
      defaultSelectedKeys: defaultSelectedKeys,
      mode: 'vertical',
      theme: 'dark',
      className: styles.menu
    }

    return (
      <Menu {...options}>
        <Item key="/dashboard/info" className={styles.item}>
          <MujiLink to="/dashboard/info">账户信息</MujiLink>
        </Item>
        <Item key="/dashboard" className={styles.item}>
          <MujiLink to="/dashboard">应用<span styles={{ fontSize: '2em' }}>生产 / 预发</span></MujiLink>
        </Item>
        <Item key="/dashboard/stable" className={styles.item}>
          <MujiLink to="/dashboard/stable">应用<span>测试 / stable</span></MujiLink>
        </Item>
        <Item key="/dashboard/traffic_stat" className={styles.item}>
          <MujiLink to="/dashboard/traffic_stat">流量报表</MujiLink>
        </Item>
      </Menu>
    )
  }
}

export default AppMenu;